import React from 'react'

import {
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  scac: { id: 'scac', label: 'SCAC Code', renderer: ValueField },
  carrierType: { id: 'carrierTypeDisplay', label: 'Type', renderer: ValueField },
}

export const CarrierListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Carriers"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
